import { render, staticRenderFns } from "./parent-list.vue?vue&type=template&id=2b3c6cf1&scoped=true"
import script from "./parent-list.vue?vue&type=script&lang=js"
export * from "./parent-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3c6cf1",
  null
  
)

export default component.exports